import { cn } from '@/lib/utils';
import { useRouter } from 'next/navigation';
import { Logo as LogoComponent } from './logo';

export function Logo({
  width,
  className,
  showDescription,
}: {
  width?: number;
  className?: string;
  showDescription?: boolean;
}) {
  const router = useRouter();
  return (
    <div className={cn('pt-4', className)}>
      <div className="flex items-center justify-center space-x-2">
        <LogoComponent
          showDescription={showDescription}
          onClick={() => router.push('/home')}
          className="select-none cursor-pointer"
          width={width ?? 250}
        />
      </div>
    </div>
  );
}
